export default __webpack_public_path__ + "static/media/MBChurchill.27995b72.png";